export default __webpack_public_path__ + "static/media/supermarkt.e28478c7.svg";